import * as React from "react"
const Phone = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#333"
        d="M14.716 10.502c-.98 0-1.941-.153-2.853-.454-.446-.153-.995-.013-1.268.267l-1.799 1.358C6.71 10.56 5.424 9.275 4.326 7.204l1.318-1.752c.343-.342.465-.842.318-1.31a9.098 9.098 0 0 1-.456-2.858C5.506.576 4.93 0 4.222 0H1.284C.576 0 0 .576 0 1.284 0 9.398 6.602 16 14.716 16c.708 0 1.284-.576 1.284-1.284v-2.93c0-.708-.576-1.284-1.284-1.284Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Phone
